// AI Task Listener Mixin
// Provides automatic draining of queued AI task events when a Stimulus controller connects
// Usage: export default class extends AiTaskListener(Controller) { ... }

export default (Base) => class extends Base {
  connect() {
    super.connect?.()
    this.drainQueuedAiTaskEvents()
  }

  drainQueuedAiTaskEvents() {
    if (!global.state?.aiTaskEvents) {
      return
    }

    // Process all queued events for this controller
    // The handleAiTaskCompleted method should call removeQueuedAiTaskEventsByType to clean up processed events
    const queuedEvents = [...global.state.aiTaskEvents]

    queuedEvents.forEach((detail) => {
      if (this.handleAiTaskCompleted) {
        this.handleAiTaskCompleted({ detail })
      }
    })
  }

  removeQueuedAiTaskEventsByType(taskType) {
    // Remove all matching events from the queue to prevent duplicate processing
    if (global.state?.aiTaskEvents) {
      global.state.aiTaskEvents = global.state.aiTaskEvents.filter(
        queuedEvent => queuedEvent.taskType !== taskType
      )
    }
  }
}